import React from 'react';

const FormFieldError = (props) => (<div className="form-field-error">{props.children}</div>);
export default FormFieldError;
